import React from 'react';
import { Row, Col } from 'antd';
import ProgressBar from '../../Progress';

const SkillsProgress = () => (
  <div>
    <h2>My Skills</h2>
    <Row gutter={[20, 20]}>
      <Col xs={24} sm={24} md={12}>
        <ProgressBar
          percent={95}
          text="Laravel"
        />
        <ProgressBar
          percent={85}
          text="PHP"
        />
        <ProgressBar
          percent={90}
          text="Javascript"
        />
        <ProgressBar
          percent={95}
          text="ReactJS"
        />

      </Col>
      <Col xs={24} sm={24} md={12}>
        <ProgressBar
          percent={85}
          text="NodeJS"
        />
        <ProgressBar
          percent={85}
          text="Gatsby"
        />
        <ProgressBar
          percent={90}
          text="Mysql"
        />
        <ProgressBar
          percent={75}
          text="MongoDB"
        />
      </Col>
    </Row>
  </div>
);

export default SkillsProgress;
